<template>
  <div class="page_padding update_journal_page">
    <div class="search_box">
      <el-button type="primary" icon="el-icon-plus" size="small" @click="add"
        >新增日志</el-button
      >
    </div>
    <Table
      class="search_table"
      :loading="loading"
      :tableData="tableData"
      :params="tableParams"
      @change-page="changePage"
      @update="getTableData"
      @edit-data="editFunc"
    ></Table>
    <Edit
      :edit="edit"
      :visible.sync="ifShowEdit"
      :initFormData="currentRow"
      :productList="productList"
      @update="getTableData"
      @close-modal="ifShowEdit = false"
    ></Edit>
  </div>
</template>

<script>
import Table from "./Table.vue";
import Edit from "./Edit.vue";
export default {
  components: {
    Table,
    Edit
  },
  data() {
    return {
      ifShowEdit: false,
      edit: false,
      tableData: [],
      currentRow: null,
      tableParams: {
        //分页器的参数
        total: 0,
        page: 1,
        size: 10
      },
      loading: false,
      // 产品列表
      productList: []
    };
  },
  mounted() {
    // this.getProductList();
    this.getTableData();
  },
  methods: {
    getTableData(val = {}) {
      this.loading = true;
      const { page: pageIndex, size: pageSize } = this.tableParams;

      this.$http({
        url: this.$api.deploy_list,
        data: {
          pageIndex,
          pageSize
        },
        method: "post"
      })
        .then(res => {
          if (res.code == 0) {
            this.tableData = res.data.list;
            this.tableParams.total = res.data.total;
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(err => {
          this.$message.error("获取更新日志列表接口请求失败");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getProductList() {
      this.$http({
        url: this.$api.company_list,
        method: "post",
        data: {}
      })
        .then(res => {
          if (res.code == 0) {
            this.productList = res.data;
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(() => {
          this.$message.error("获取所属产品列表接口请求失败");
        });
    },
    add() {
      this.currentRow = null;
      this.edit = false;
      this.ifShowEdit = true;
    },
    // 点击编辑按钮
    editFunc(row) {
      this.currentRow = row;
      this.edit = true;
      this.ifShowEdit = true;
    },
    changePage(page) {
      this.tableParams.page = page;
      this.getTableData();
    }
  }
};
</script>

<style lang="less" scoped>
.search_box {
  display: flex;
  justify-content: end;
}
.update_journal_page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .search_table {
    flex: 1;
    height: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/views/UpdateJournal/index.vue